const PATH = process.env.VUE_APP_PATH;

export const lessonCopyMixin = {
  data: () => {
    return {
      raspSeartchMode: false,
      clipboard: {},
      copyCount: 0,
      lessonInfo: {
        predm: '',
        lessons: []
      }
    }
  },
    methods: {
        copyToLesson(to, day, idl, copy){
          to.groups = this.clipboard.groups
          this.copyCount++;
          if (this.clipboard.kab[0] == "<") to.kab = this.clipboard.kab
          else {
            to.kab = this.clipboard.kab.split('-')[0]+'-___'
          }
          to.predm = this.clipboard.predm
          to.type = this.clipboard.type
          to.copied = true
          to.realcopy = copy
          to.unsaved = true
          if (to.kab[0] == "<") {
            this.winKab.day = day
            this.winKab.lesson = to
            this.changeKab(to.kab)
          }
          else this.getKab(day, to.kab, to, idl);
        },
        async lessonAddMulti(lessons){
          this.axios.post(PATH + '/api/db/self/lesson/multi', {
            login: this.login,
            passwordAES: this.passwordAES,
            lessons
          }).then(()=>{
            this.loadData()
            this.$bvModal.msgBoxOk('Выбранные занятия успешно добавлены', {
              title: 'Подтверждение',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true
            })
          }).catch ((e)=>{console.log(e?.message)})
        },
        async addSelfLesson(rec){
          var data = {
            groups: [rec.lesson.groups], 
            kab: rec.lesson.kab, 
            predm: rec.lesson.predm, 
            type: rec.lesson.type, 
            time: rec.lesson.time
          }
          var payload = {
            login: this.login,
            passwordAES: this.passwordAES,
            lesson: data,
            day: rec.day,
          }
          try {
            var response = await this.axios.post(PATH + '/api/db/self/lesson', payload)
            if (response.data.status === 'occupied') {
              // Слот уже занят — показываем существующее занятие и спрашиваем,
              // что делать (заменить локальное / продолжить с коллизией).
              var ex = response.data.existing || {}
              var label = `${ex.predm || '(пусто)'} ${ex.type ? '(' + ex.type + ')' : ''} ${(ex.groups || []).join(', ')}`.trim()
              var localOnly = !!response.data.local_only
              var msg = localOnly
                ? `В указанное время уже есть занятие: ${label}. Заменить?`
                : `В это время уже есть занятие: ${label}. В результате добавления возникнет коллизия. Продолжить?`
              var confirmed = await this.$bvModal.msgBoxConfirm(msg, {
                title: 'Занятие в это время',
                okTitle: localOnly ? 'Да' : 'Продолжить',
                cancelTitle: 'Нет',
                okVariant: 'warning',
                centered: true,
                size: 'sm',
              }).catch(() => false)
              if (!confirmed) return
              payload.confirm = localOnly ? 'replace' : 'collision'
              response = await this.axios.post(PATH + '/api/db/self/lesson', payload)
              if (response.data.status !== 'OK') return
            }
            this.loadData()
            this.$bvModal.msgBoxOk('Занятие успешно добавлено', {
              title: 'Подтверждение',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true
            })
          } catch (e) { console.log(e?.message) }
        },
        async editSelfLesson(rec){
          var payload = {
            login: this.login,
            passwordAES: this.passwordAES,
            id: rec._id,
            origDay: rec.origDay,
            origTime: rec.origTime,
            day: rec.day,
            lesson: {
              time: rec.lesson.time,
              predm: rec.lesson.predm,
              type: rec.lesson.type,
              kab: rec.lesson.kab,
              groups: [rec.lesson.groups]
            }
          }
          try {
            var response = await this.axios.post(PATH + '/api/db/self/lesson/edit', payload)
            if (response.data.status === 'occupied') {
              // Занятие переносится на слот, который уже занят другой записью —
              // тот же выбор, что и при добавлении: заменить/коллизия.
              var ex = response.data.existing || {}
              var label = `${ex.predm || '(пусто)'} ${ex.type ? '(' + ex.type + ')' : ''} ${(ex.groups || []).join(', ')}`.trim()
              var localOnly = !!response.data.local_only
              var msg = localOnly
                ? `В указанное время уже есть занятие: ${label}. Заменить?`
                : `В это время уже есть занятие: ${label}. В результате переноса возникнет коллизия. Продолжить?`
              var confirmed = await this.$bvModal.msgBoxConfirm(msg, {
                title: 'Занятие в это время',
                okTitle: localOnly ? 'Да' : 'Продолжить',
                cancelTitle: 'Нет',
                okVariant: 'warning',
                centered: true,
                size: 'sm',
              }).catch(() => false)
              if (!confirmed) return
              payload.confirm = localOnly ? 'replace' : 'collision'
              response = await this.axios.post(PATH + '/api/db/self/lesson/edit', payload)
              if (response.data.status !== 'OK') return
            }
            this.loadData()
            this.$bvModal.msgBoxOk('Занятие успешно изменено', {
              title: 'Подтверждение',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true
            })
          } catch (e) { console.log(e?.message) }
        },
        async changeKab(kab){
          var l = this.winKab.lesson
          var data = {
            groups: l.groups, 
            kab: l.kab, 
            predm: l.predm, 
            type: l.type, 
            time: l.time, 
            copied: l.copied,
            realcopy: l.realcopy
          }
          this.axios.post(PATH + '/api/db/changekab', {
            login: this.login,
            passwordAES: this.passwordAES,
            lesson: data,
            newkab: kab,
            day: this.winKab.day,
          }).then(()=>{
            if(!this.winKab.lesson.copied) this.winKab.lesson.oldkab = this.winKab.lesson.kab;
            this.winKab.lesson.kab = kab;
            this.winKab.lesson.unsaved = false;
            localStorage.dump = JSON.stringify(this.days)
          }).catch ((e)=>{console.log(e?.message)})
        },
        async changeKabCancel(){
          this.axios.post(PATH + '/api/db/changekab/cancel', {
            login: this.login,
            passwordAES: this.passwordAES,
            lesson: this.winKab.lesson,
            day: this.winKab.day,
          }).then(()=>{
            this.winKab.lesson.kab = this.winKab.lesson.oldkab; 
            delete this.winKab.lesson.oldkab;
            localStorage.dump = JSON.stringify(this.days)
          }).catch ((e)=>{console.log(e?.message)})
        },
        // занятие, записанное в ISS, — сначала запись ISS (delLessonIss)
        async delLesson(lesson, day, idd, idl){
          if (String(lesson.in_iss) === '1' && !lesson.copied) return this.delLessonIss(lesson, day, idd, idl)
          var url = '/api/db/del'
          this.axios.post(PATH + url, {
            login: this.login,
            passwordAES: this.passwordAES,
            lesson,
            day,
          }).then(()=>{
            this.applyLessonDeleted(lesson, idd, idl)
          }).catch ((e)=>{console.log(e?.message)})
        },
        // занятие удалено (из расписания) — очистить слот в интерфейсе
        applyLessonDeleted(lesson, idd, idl){
          if(!lesson.copied) this.filteredDays[idd].lessons[idl].deleted = true;
          this.filteredDays[idd].lessons[idl].predm = '';
          this.filteredDays[idd].lessons[idl].type = '';
          this.filteredDays[idd].lessons[idl].groups = [];
          this.filteredDays[idd].lessons[idl].kab = '';
          this.filteredDays[idd].lessons[idl].in_iss = 0;
          this.filteredDays[idd].lessons[idl].copied = false;
          this.filteredDays[idd].lessons[idl].unsaved = false;
          this.filteredDays[idd].lessons[idl].message = '';
          if(this.raspSeartchMode)this.copyCount--;
          localStorage.dump = JSON.stringify(this.days)
        },
        // Удаление занятия, записанного в ISS: подтверждение -> запись ISS ->
        // расписание. Ход — окно issDelWin по сообщениям WS. Ошибка ISS
        // (утверждено, период закрыт) — занятие в расписании остаётся.
        async delLessonIss(lesson, day, idd, idl){
          const label = `${lesson.predm} · ${day.split('-').reverse().join('.')} ${lesson.time} · ${(lesson.groups || []).join(', ')}`
          const ok = await this.$bvModal.msgBoxConfirm(
            `Занятие «${lesson.predm}» ${day.split('-').reverse().join('.')} ${lesson.time} записано в журнал ISS. ` +
            'Сначала будет удалена запись из ISS, затем занятие из расписания. Если запись утверждена или период закрыт, ничего не удалится.',
            { title: 'Удалить занятие из ISS и расписания?', okTitle: 'Удалить', okVariant: 'danger', cancelTitle: 'Отмена', centered: true })
          if (!ok) return
          const opId = Date.now().toString(36) + Math.random().toString(36).slice(2, 6)
          this.issDel = { label, opId, start: this.messages.length, running: true, result: null }
          this.$bvModal.show('issdelwin')
          try {
            const { data } = await this.axios.post(PATH + '/api/iss/lesson/delete', {
              auth: { login: this.login, passwordAES: this.passwordAES, semester: this.selectedSemester },
              data: { day, time: lesson.time, opId },
            }, { timeout: 180000 })
            this.issDel.result = data
            if (data.ok && data.lessonDeleted) {
              const predm = lesson.predm
              this.applyLessonDeleted(lesson, idd, idl)
              // соседние пары, которые покрывала запись ISS на 4 ч, — без «в ISS»
              const d = this.days.find(x => x.day === day)
              if (d && data.siblings) d.lessons.forEach(l => { if (l.predm === predm && data.siblings.includes(l.time)) l.in_iss = 0 })
              localStorage.dump = JSON.stringify(this.days)
            }
          } catch (e) {
            const err = (e.response && e.response.data && e.response.data.error) ||
              (e.code === 'ECONNABORTED' ? 'ISS не ответил вовремя. Проверьте журнал ISS и обновите расписание.' : 'Сервер не ответил.')
            this.issDel.result = { ok: false, error: err }
          } finally {
            this.issDel.running = false
          }
        },
        async infoLesson(lesson){
          // Собираем все занятия с таким же названием предмета
          const lessonsWithSamePredm = [];
          
          this.days.forEach((dayObj, dayIndex) => {
            dayObj.lessons.forEach((lessonObj, lessonIndex) => {
              if (lessonObj.predm === lesson.predm && lessonObj._id) {
                lessonsWithSamePredm.push({
                  ...lessonObj,
                  day: dayObj.day,
                  dayIndex,
                  lessonIndex
                });
              }
            });
          });
          
          // Сортируем по дате и времени в обратном порядке (новые сначала)
          lessonsWithSamePredm.sort((a, b) => {
            const dateA = new Date(a.day + ' ' + (a.time || '00:00'));
            const dateB = new Date(b.day + ' ' + (b.time || '00:00'));
            return dateB - dateA; // Обратный порядок
          });
          
          // Устанавливаем данные для модального окна
          this.lessonInfo = {
            predm: lesson.predm,
            lessons: lessonsWithSamePredm
          };
          
          // Показываем модальное окно
          this.$bvModal.show('lessoninfowin');
        },
    }
}